import immJs from 'lodash';

function ConnectReducer(state = {}, action) {
  const newState = immJs.cloneDeep(state);

  switch (action.type) {
    case 'GET_CONVERSATION':
      newState.conversation = action.payload;
      newState.conversationId = action.payload.Id;
      newState.isLoading = false;
      newState.error = null;
      return {
        ...state,
        ...newState,
      };

    case 'CLEAR_CONVERSATION':
      newState.conversation = null;
      newState.conversationId = null;
      newState.error = null;
      newState.isLoading = false;
      return {
        ...state,
        ...newState,
      };

    default:
      return { ...state };
  }
}

function getConversation(state) {
  return state.ConnectReducer.conversation;
}

function getConversationId(state) {
  return state.ConnectReducer.conversationId;
}

export {
  ConnectReducer,
  getConversation,
  getConversationId,
};
